import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
import { initGTMFromComponent } from '@/helpers/initGTM';


export default /*@__PURE__*/_defineComponent({
  __name: 'CookieConsentComponent',
  setup(__props) {

const onAccept = () => {
  console.log('User accepted cookies');
  localStorage.setItem('cookiesAccepted', 'true');
  initGTMFromComponent();
};

const onDecline = () => {
  console.log('User declined cookies');
};

const onStatus = (status: string | null) => {
  console.log('[CookieConsent] Cookie status is:', status ?? 'null (no decision yet)');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueCookieAcceptDecline), {
    "element-id": "cookie-consent-banner",
    debug: false,
    "disable-decline": false,
    "show-postpone-button": false,
    onClickedAccept: onAccept,
    onClickedDecline: onDecline,
    onStatus: onStatus
  }, {
    message: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode(" Utilizamos cookies para garantizar que obtengas la mejor experiencia en nuestro sitio web. "),
      _createElementVNode("a", {
        href: "/cookies-policy",
        target: "_blank",
        class: "btn-secondary-s btn-underline-black more-cookies"
      }, " Aprende más... ", -1)
    ])),
    acceptContent: _withCtx(() => _cache[1] || (_cache[1] = [
      _createTextVNode("Aceptar")
    ])),
    declineContent: _withCtx(() => _cache[2] || (_cache[2] = [
      _createTextVNode("Rechazar las no esenciales")
    ])),
    _: 1
  }))
}
}

})